import type { ComponentType } from 'react';

const withPersonalSurveyDisplayName = <T extends object>(
  WC: ComponentType<T>,
): ComponentType<T> => {
  const MyComp = (props: T) => <WC {...props} />;
  MyComp.displayName = 'PersonalSurvey';
  return MyComp;
};

export default withPersonalSurveyDisplayName;
